import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { iesLogin } from "./service.js";
import { setToken, getUser, getTranslation } from "../service/service.js";
import { getWizmeIdFromIESCode } from "./wizme_auth_service.js";

// IES NEW CODE
import { redirectToIESLogin } from "./auth_service_ies.js";
import styles from "../assets/containers/FullPageLoader.module.css";
import { EagleIcon } from "../components/EagleIcon";

const AuthCallback = () => {
  const history = useHistory();

  useEffect(() => {
    const authenticate = async () => {
      try {
        const hash = window.location.hash;
        const queryString = hash.includes("?") ? hash.split("?")[1] : "";
        const params = new URLSearchParams(queryString);

        const code = params.get("code");
        const routing_region = params.get("x-routingregion") || "US";
        const receivedState = params.get("state");
        const expectedState = sessionStorage.getItem("oauth_state");

        if (!code) {
          console.error("Code not found in URL.");
          history.push("/");
          return;
        }

        if (!receivedState || receivedState !== expectedState) {
          console.error("Incorrect state!");
          history.push("/");
          return;
        }

        const currentUrl = new URL(window.location.href);
        const hostname = (currentUrl.hostname || "").toLowerCase();
        const isNonCatchupCallbackEnvironment =
          hostname.includes("stg") || hostname.includes("dev");
        const origin = currentUrl.origin;
        const redirect_uri = isNonCatchupCallbackEnvironment
          ? `${origin}/login_callback`
          : `${origin}/catchup/login_callback`;

        console.log("[AuthCallback] redirect_uri resolved", {
          hostname,
          redirect_uri,
        });

        const responseIES = await iesLogin({
          code,
          redirect_uri,
          routing_region,
        });

        if (!responseIES) {
          throw new Error("IES result not sucessful.");
        }

        if (!responseIES.user_exists) {
          redirectToIESLogin();
          return;
        }

        // Persist the normalized token before firing any authenticated request; overriding the cookie afterwards
        // with the raw responseIES stripped token_type/access_token from the axios interceptor, causing 401s
        // that were only recovered by the response interceptor's silent refresh (ARTFRAN-15306).
        await setToken(responseIES);

        let getUserInfo = await getUser();

        // ---- Wizme: persist platformId on user-info -----
        const iesAccessToken =
          responseIES.oauth_data && responseIES.oauth_data.access_token;

        const wizmeId = await getWizmeIdFromIESCode(iesAccessToken);

        if (getUserInfo && getUserInfo.data && wizmeId) {
          getUserInfo.data.wizmeId = wizmeId;
        }
        // --- End Wizme ---

        // Clear previous data
        localStorage.removeItem("languagePack");
        localStorage.removeItem("currentBookId");
        localStorage.removeItem("user-info");

        localStorage.setItem("user-info", JSON.stringify(getUserInfo));
        localStorage.setItem(
          "token_info_hint",
          JSON.stringify(responseIES.oauth_data.id_token),
        );

        localStorage.setItem("userFromIES", true);

        // --- Language ---
        var userData = (getUserInfo && getUserInfo.data) || getUserInfo;
        var availableLanguages = userData && userData.available_languages;
        if (availableLanguages && availableLanguages.length === 1) {
          var languageCode;
          var regionUser = userData.region_user;
          var regionCode = userData.region_code;
          if (
            regionUser &&
            regionUser !== "BRA" &&
            availableLanguages[0].code === "en"
          ) {
            languageCode = regionCode;
          } else {
            languageCode = availableLanguages[0].code;
          }
          try {
            var translationRes = await getTranslation(languageCode);
            var languagePack = translationRes.data || translationRes;
            languagePack.selectedLanguage = availableLanguages[0].code;
            languagePack.languageCode = languageCode;
            localStorage.setItem("languagePack", JSON.stringify(languagePack));
            console.log("Language pack set:", languageCode);
          } catch (langErr) {
            console.warn(
              "Could not fetch translation, defaulting to en:",
              langErr,
            );
          }
        } else if (availableLanguages && availableLanguages.length > 1) {
          console.log(
            "Multiple languages available, deferring to SelectLanguage modal",
          );
        }
        // --- End Language ---

        history.push("/#/catchup/classes/list");
        window.location.reload();
      } catch (error) {
        console.error("Authentication error:", error);
        history.push("/");
      }
    };

    authenticate();
  }, [history]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-70 z-50">
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className={styles.loaderContainer}>
          <div className={styles.loaderCenter} />
          <div className={styles.loaderWheel} />
          <EagleIcon className={styles.loaderEagle} />
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
